<template>
  <div>
    <Head title="Applicant Contact" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_details.id}/view`">
        {{ data.applicant_details.id }}. {{ data.applicant_details.name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ $t('treatments.new') }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <Form :form-data="form" :treatment_types="filteredTypes" :volunteers="volunteers" is-new="true" />
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ $t('global.create') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import Form from '@/Pages/Treatments/Form'
import filter from 'lodash/filter'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    Form,
  },
  layout: Layout,
  props: {
    data: Object,
    treatmentTypes: {
      type: Array,
      default: function () {
        return []
      },
    },
    volunteers: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        treatment_type_id: '',
        volunteer_id: '',
        reason_closed: '',
        date_open: '',
        date_closed: '',
        paper_file: 0,
      }),
    }
  },
  computed: {
  //Types filteren op basis van permissions
    filteredTypes(){
      let store = this.$store
      let arr = this.treatmentTypes
      if(!this.$store.getters.can('admin')){
        arr = filter(this.treatmentTypes, function (o) {
          let role = o.code.toLowerCase()
          if (role == 'bénévole' && store.state.permissions.includes('bénévole')) {
            return 'bénévole'
          }

          if (role == 'visiteur_bénévole' && store.state.permissions.includes('visiteur_bénévole')) {
            return 'visiteur_bénévole'
          }

          if (role == 'pane' && store.state.permissions.includes('social')) {
            return 'social'
          }
          if (role == 'pane' && store.state.permissions.includes('secretariat')) {
            return 'pane'
          }

          return store.state.permissions.includes(role.replace(/[^a-zA-Z0-9 ]/g, ''))
        })
      }

      return arr
    },
  },
  methods: {
    store() {
      this.form.post(`/applicants/${this.data.applicant_id}/treatments/create`)
    },
  },
}
</script>
